export const LOYALTY_ACCOUNT_API = 'loyalty-account';
